import type { UploadKind, UploadCategoryKind } from "@/lib/upload/kinds";

export type AttachGroupRecord = {
  id: string;
  parentId: string | null;
  name: string;
  sortOrder: number;
  count: number;
  childCount: number;

  scope: "personal" | "org" | "division";
  isDefault: boolean;
  writable: boolean;
  renamable: boolean;
  deletable: boolean;
  sortable: boolean;
};

export type AttachGroupInput = {
  name: string;
  parentId?: string | null;
  sortOrder?: number;
};

export type AttachFileRecord = {
  id: string;
  url: string;
  thumbUrl?: string;
  fileName: string;
  originalName: string;
  mimeType: string | null;
  fileSize: number;
  width: number | null;
  height: number | null;
  kind: string;
  groupId: string;
  source: string;
  module: string | null;
  createdAt: string;
  owned?: boolean;
};

export type AttachQuotaRecord = {
  usedSizeBytes: number;

  maxSizeBytes: number;
  baseSizeBytes: number;
  packSizeBytes: number;
  usedFileCount: number;
  maxFileCount: number;
  /** 已超额：仅禁止新上传，已有文件不受影响 */
  overQuota: boolean;
  overSizeBytes: number;
  packExpiresAt: string | null;
  expiringSoon: boolean;
};

export type AttachListResponse = {
  items: AttachFileRecord[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  quota: AttachQuotaRecord;
};

export type AttachUploadRulesRecord = {
  kind: UploadKind;
  extensions: string[];
  maxSizeMb: number;
  accept: string;
  uploadContext?: {
    visibilitySelectable: boolean;
    visibilityOptions: Array<{ value: string; label: string }>;
    defaultVisibility: string;
  };
};

export type AttachPickerInitResponse = {
  rules: AttachUploadRulesRecord;
  groups: AttachGroupRecord[];
  items: AttachFileRecord[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  quota: AttachQuotaRecord;
};

export type AttachPickerModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  kind: UploadKind;
  module?: string;
  acceptExtensions?: string[];
  allowedKinds?: UploadCategoryKind[];

  onSelect: (file: AttachFileRecord) => void;

  multiple?: boolean;

  maxCount?: number;

  onSelectMany?: (files: AttachFileRecord[]) => void;
};

export const ATTACH_PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 500] as const;

export type AttachPageSize = (typeof ATTACH_PAGE_SIZE_OPTIONS)[number];

export type AttachViewMode = "grid" | "list";
